<template>
	<a class="button" 
  @click="handleClick" href="javascript:void(0)" :class="[{'is-loading': loading},{'is-disabled': disabled},]">
  
  <span class="icon" v-if="showicon">
    <i  :class="[iconclass]"></i>
  </span>
  <span class="text"><slot></slot></span>
  <Ripple v-show="isRippled" :isLight="true"></Ripple>
</a>
</template>
<script>
  export default {
    name: "uButton",
    props: {
      isRippled: {
        type: Boolean,
        default: true
      },
      disabled: Boolean,
      loading: {
        type: Boolean,
        default: false
      },
      iconclass: {
        type: String,
        default: '',
      },
      showicon:Boolean,
      active: Boolean
    },
    methods: {
      handleClick(event) {
      	if(!this.disabled){
      		this.$emit("click", event);
      	}else{
      		return;
      	}
        
      }
    }
  };
</script>


// WEBPACK FOOTER //
// src/components/uButton/uButton.vue